import { motion } from "framer-motion";
import { useState } from "react";

const MobileOppoScroll = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});

    const handleSwipe = (direction) => {
        if (direction === "next") {
            setCurrentIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
        } else {
            setCurrentIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
        }
    };

    const toggleDescription = (id) => {
        setExpandedDescriptions(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const truncateText = (text, maxLength = 150) => {
        if (text.length <= maxLength) return text;
        return text.substring(0, text.lastIndexOf(' ', maxLength)) + '...';
    };

    return (
        <div className="min-h-screen bg-cream">
            <motion.div
                className="h-screen w-full relative overflow-hidden touch-none"
                onPanEnd={(e, info) => {
                    if (Math.abs(info.offset.x) > 50) {
                        handleSwipe(info.offset.x > 0 ? "prev" : "next");
                    }
                }}
            >
                <motion.div
                    className="h-full w-full"
                    animate={{ x: `-${currentIndex * 100}%` }}
                    transition={{ type: "spring", damping: 20 }}
                    style={{ display: "flex" }}
                >
                    {items.map((item, index) => (
                        <div
                            key={item.id}
                            className="h-full w-full flex-shrink-0"
                        >
                            <div className="relative h-full w-full">
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="absolute inset-0 w-full h-1/2 object-cover"
                                />

                                {/* Modification ici : ajout de max-h-[50vh] et overflow-y-auto */}
                                <div className={`absolute bottom-0 w-full h-1/2 max-h-[50vh] p-6 overflow-y-auto scrollbar-thin scrollbar-thumb-cocoa scrollbar-track-cream ${index % 2 ? "bg-cocoa text-cream" : "bg-cream text-cocoa"
                                    }`}>
                                    <motion.h2
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        className="text-4xl font-medium mb-4"
                                    >
                                        {item.title}
                                    </motion.h2>
                                    <div className={`w-full h-0.5 mb-4 ${index % 2 ? "bg-cream" : "bg-cocoa"
                                        }`} />
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        className="space-y-4"
                                    >
                                        <p className="text-sm font-light">
                                            {expandedDescriptions[item.id]
                                                ? item.description
                                                : truncateText(item.description)}
                                        </p>
                                        {item.description.length > 150 && (
                                            <button
                                                onClick={() => toggleDescription(item.id)}
                                                className={`text-sm font-medium py-2 px-4 rounded-full ${index % 2
                                                        ? "bg-cream text-cocoa hover:bg-opacity-90"
                                                        : "bg-cocoa text-cream hover:bg-opacity-90"
                                                    } transition-colors`}
                                            >
                                                {expandedDescriptions[item.id] ? "Voir moins" : "Voir plus"}
                                            </button>
                                        )}
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    ))}
                </motion.div>

                <button
                    onClick={() => handleSwipe("prev")}
                    className="absolute left-4 top-1/4 z-10 p-2 bg-cream text-cocoa rounded-full"
                >
                    ←
                </button>
                <button
                    onClick={() => handleSwipe("next")}
                    className="absolute right-4 top-1/4 z-10 p-2 bg-cream text-cocoa rounded-full"
                >
                    →
                </button>
            </motion.div>
        </div>
    );
};

const items = [
    {
        id: 1,
        title: "THEA – LA CUISINE ARCLINEA",
        description:
            "L’Innovation et l’esthétique de la cuisine moderne\n\n Avec Thea, Arclinea adopte une approche qui allie minimalisme raffiné et fonctionnalité plus que design, caractéristique des cuisines sans poignées aux lignes épurées.\n\n Le résultat est un espace rationnel et sophistiqué, offrant une polyvalence sans compromis. Thea incarne les principes fondamentaux des conceptions d’Arclinea, tout en apportant une flexibilité innovante qui permet une adaptabilité optimale, notamment grâce à ses poignées modulables, pouvant être intégrées horizontalement ou verticalement. Si son nom rend hommage à une création des années 60, Thea est aujourd’hui le cœur même de notre évolution créative, une véritable référence dans l’univers du mobilier haut de gamme. Une cuisine Théa de chez Arclinea,  configurés de différentes manières subliment notre Showroom, tous visibles et configurable chez ISILIVING à Aix-en-Provence, avec le reste de la collection USM Haller.",
        img: "/assets/images/oppo-scroll/ARCLINEA - THEA COLLECTION VISUEL PHOTOS DEFILANTES.jpeg",
    },
    {
        id: 2,
        title: "PLATNER – LA COLLECTION KNOLL",
        description:
            "L’icône du design moderne et raffiné\n\n Imaginée en 1966 par Warren Platner pour Knoll, la collection Platner incarne l’élégance intemporelle du design. Née de la volonté de son créateur d’apporter une touche de raffinement et de délicatesse au modernisme, elle s’inspire des styles décoratifs classiques, tels que l’opulence du Louis XV, tout en conservant une esthétique contemporaine et sculpturale. Cette collection emblématique, à la fois sophistiquée et aérienne, marie avec brio design architectural et artisanat d’exception, faisant d’elle une référence incontournable dans l’univers du mobilier haut de gamme. Les produits de la collection Platner de chez Knoll, rendant plus élégant notre Showroom, visibles chez ISILIVING à Aix-en-Provence.",
        img: "/assets/images/oppo-scroll/KNOLL - PLATNER COLLECTION VISUEL PHOTOS DEFILANTES.jpg",
    },
    {
        id: 3,
        title: "AMANU – LA NOUVELLE COLLECTION TRIBU",
        description:
            "L’élégance du mobilier d’extérieur avec un engagement durable\n\n La collection sophistiquée Amanu de chez Tribù repousse les frontières entre intérieur et extérieur, offrant un équilibre parfait entre esthétique épurée, bien-être absolu et engagement durable. Son design raffiné allie harmonieusement confort et élégance, créant des espaces extérieurs à la fois chaleureux et intemporels. Les chaises de repas se démarquent par leurs assises suspendues en fibre de chanvre, minutieusement tissées à la main, qui semblent flotter avec légèreté au sein d’un cadre en teck massif aux lignes épurées. Au cœur de cette collection, le canapé trois places emblématique offre une assise généreuse et accueillante, parfaite pour partager des moments de détente. Le nouveau lit de jour invite à la relaxation, que ce soit sous les rayons du soleil ou sous un ciel étoilé. Une sélection de tables basses aux formes variées vient compléter l’ensemble, chacune reprenant l’élégance distinctive de la table de repas Amanu, apportant ainsi une harmonie sophistiquée aux espaces extérieurs. Avec son design unique et ses matériaux d’exception, la collection Amanu incarne l’art de vivre en plein air dans toute sa splendeur.",
        img: "/assets/images/oppo-scroll/TRIBU - AMANU COLLECTION VISUEL PHOTOS DEFILANTES.jpg",
    },
    {
        id: 4,
        title: "USM VERT OLIVE – LA COLLECTION",
        description:
            "Le style naturel et élégant intégré à la collection permanente\n\n Lancée en 2023, notre collection spéciale Vert Olive a rencontré un succès remarquable. Nous sommes ravis d’annoncer l’intégration de cette gamme dans la collection permanente, venant compléter harmonieusement nos best-sellers. Cette édition exclusive insuffle une touche organique et raffinée à tous les intérieurs, embellissant chaque espace avec son design intemporel et sa teinte naturelle sophistiquée. Plusieurs meubles USM configurés de différentes manières subliment notre Showroom, tous visibles et configurable chez ISILIVING à Aix-en-Provence, avec le reste de la collection USM Haller.",
        img: "/assets/images/oppo-scroll/USM - VERT OLIVE COLLECTION VISUEL PHOTOS DEFILANTES.jpg",
    },
];

export default MobileOppoScroll;